import createIcon from '../../createIcon';

/**
 * @component @name LocalOffer
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNDEgMTEuNThMMTIuNDEgMi41OEMxMi4wNSAyLjIyIDExLjU1IDIgMTEgMkg0QzIuOSAyIDIgMi45IDIgNFYxMUMyIDExLjU1IDIuMjIgMTIuMDUgMi41OSAxMi40MkwxMS41OSAyMS40MkMxMS45NSAyMS43OCAxMi40NSAyMiAxMyAyMkMxMy41NSAyMiAxNC4wNSAyMS43OCAxNC40MSAyMS40MUwyMS40MSAxNC40MUMyMS43OCAxNC4wNSAyMiAxMy41NSAyMiAxM0MyMiAxMi40NSAyMS43NyAxMS45NCAyMS40MSAxMS41OFpNNS41IDdDNC42NyA3IDQgNi4zMyA0IDUuNUM0IDQuNjcgNC42NyA0IDUuNSA0QzYuMzMgNCA3IDQuNjcgNyA1LjVDNyA2LjMzIDYuMzMgNyA1LjUgN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalOffer = createIcon('LocalOffer', [
  [
    'path',
    {
      d: 'M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5C7 6.33 6.33 7 5.5 7Z',
      key: 'i6a10p',
    },
  ],
]);

export default LocalOffer;
